var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex lg:flex-row flex-col gap-4" },
    [
      _c(
        "v-col",
        { staticClass: "bg-white" },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c("title-label", {
                    attrs: {
                      label: _vm.$t("message.codMessage.title"),
                      "prepend-icon": "mdi-email",
                    },
                  }),
                  _c("text-editor", {
                    staticClass: "mt-3",
                    attrs: { state: _vm.state["codSummaryText"] },
                    on: {
                      submit: function ($event) {
                        return _vm.submit("codSummaryText")
                      },
                    },
                    model: {
                      value: _vm.form.codSummaryText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "codSummaryText", $$v)
                      },
                      expression: "form.codSummaryText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "w-full bg-white",
          style: { maxWidth: "100%" },
          attrs: { cols: "4" },
        },
        [
          _c(
            "v-card",
            { staticClass: "p-7 flex flex-col gap-7", attrs: { flat: "" } },
            [
              _c("title-label", {
                attrs: {
                  label: _vm.$t("message.codMessage.previewSummaryCod"),
                  "prepend-icon": "mdi-email",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "p-1 rounded-lg text-xs flex flex-col gap-3",
                  style: { boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" },
                },
                [
                  _c("div", { staticClass: "flex items-center p-2 pb-0" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/example_message/left.png"),
                      },
                    }),
                    _c("div", { staticClass: "flex items-center gap-1 pl-4" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/example_message/logo.png"),
                        },
                      }),
                      _c("div", { staticClass: "flex flex-col" }, [
                        _c("span", { staticClass: "text-sm font-medium" }, [
                          _vm._v("Shipnity"),
                        ]),
                        _c("span", { staticClass: "text-disabled" }, [
                          _vm._v("Messenger"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex gap-3 items-center justify-end" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/example_message/call.png"),
                          },
                        }),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/example_message/video_call.png"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "px-7 py-3",
                      style: {
                        borderRadius: "32px 32px 32px 4px",
                        backgroundColor: "#E9E9F2",
                      },
                    },
                    [
                      _c("p", { staticClass: "mt-3" }, [
                        _vm._v(" เลขที่ใบสั่งซื้อ: MRA12 "),
                        _c("br"),
                        _vm._v(" รายการสินค้า "),
                        _c("br"),
                        _vm._v(" กางเกงเด็ก ราคา 100.00 บาท "),
                        _c("br"),
                        _c("br"),
                        _vm._v(" ค่าส่งแบบ EMS 0.00 บาท "),
                        _c("br"),
                        _vm._v(" ยอดรวม 100.00 บาท "),
                        _c("br"),
                        _c("br"),
                      ]),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.form.codSummaryText),
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }